<div class="row">
  <div class="col pb-5">
    <!-- <h6><strong>Logged out</strong></h6> -->
  </div>
</div>
<div class="row">
  <div class="col-md-1">

  </div>
  <div class="col-md">
    <img src="design/images/Forbidden.png" class="forb-img" />
    <h1>You have successfully logged out!</h1>
    <!-- <p>To re-login press the home button</p> -->
    <a routerLink="/home"><button class="btn btn-secondary mb-5">Home</button></a>
  </div>
</div>